function offersToProductOffers(offers) {
    return offers.reduce((acc, { name, prices }) => {
        prices.forEach((price) => {
            acc[price.productId] = {
                ...acc[price.productId],
                [name]: { ...price },
            };
        });
        return acc;
    }, {});
}
export const getOfferCards = ({ products, offers, }) => {
    const offerPrices = offersToProductOffers(offers);
    return products.map((product) => {
        const { id, isMostPopular } = product;
        return {
            ...product,
            isMostPopular: isMostPopular || false,
            offerPrice: offerPrices[id] || {},
        };
    });
};
const currencyMap = {
    EUR: '€',
};
export function mapCurrencyToSymbol(currency) {
    return currencyMap[currency];
}
